<template>
  <div>
    <el-table :data="energyConsumptionTemp" border>
      <el-table-column label="表项" width="80px" prop="meterReadType" align="center">
        <template slot-scope="scope">{{meterReadTypeDict[scope.row.meterReadType]}}</template>
      </el-table-column>
      <el-table-column label="户号" align="center">
        <el-input slot-scope="scope" v-model="scope.row.houseNumber" size="small" :maxlength="50" placeholder="请填写户号" />
      </el-table-column>
      <el-table-column label="读表" align="center">
        <template slot-scope="scope">
          <el-input v-model.number="scope.row.meterReadNumber" class="number-input" size="small" :maxlength="10" @change="val=>checkPrice(val,scope.$index)" :placeholder="
              `请填写${meterReadTypeDict[scope.row.meterReadType]}读数`
            " />
          <span class="unit">{{scope.row.meterReadType === 'WATERMETER' ? '吨' : '度'}}</span>
        </template>
      </el-table-column>
    </el-table>

    <div class="dlg-btn-group">
      <el-button @click="emitClose">取 消</el-button>
      <el-button type="primary" @click="submit">确 定</el-button>
    </div>
  </div>
</template>

<script>
const meterReadType = {
  ELECTRICMETER: '电表',
  WATERMETER: '水表',
  GASMETERREAD: '燃气',
}

// const energyConsumption: [
//   {
//     meterReadType: 'WATERMETER',
//     houseNumber: '',
//     meterReadNumber: '',
//   },
//   {
//     meterReadType: 'ELECTRICMETER',
//     houseNumber: '',
//     meterReadNumber: '',
//   },
//   {
//     meterReadType: 'GASMETERREAD',
//     houseNumber: '',
//     meterReadNumber: '',
//   },
// ]

export default {
  props: {
    energyConsumption: {
      type: Array,
      required: true,
    },
  },

  data () {
    return {
      meterReadTypeDict: meterReadType,

      energyConsumptionTemp: JSON.parse(JSON.stringify(this.energyConsumption)),

    }
  },

  mounted () {
    console.log(200)
  },
  created () {

  },
  methods: {
    checkPrice (val, index) {
      // 正数包含小数点 /[^\d.]/g, ''
      // 正整数 /\D+/, ''
      let pval = ''
      pval = pval.replace(/^\./g, '') // 必须保证第一个为数字而不是.
      pval = val.replace(/[^\d.]/g, '')
      pval = pval.replace(/\.{2,}/g, '.') // 只保留第一个. 清除多余的
      pval = pval.replace('.', '$#$').replace(/\./g, '').replace('$#$', '.') // 不能重复出现点
      pval = pval.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3') // 只能输入两个小数
      let len1 = pval.substr(0, 1);
      let len2 = pval.substr(1, 1);
      // 如果第一位是0，第二位不是点，就用数字把点替换掉
      if (pval.length > 1 && len1 === '0' && len2 !== '.') {
        pval = pval.substr(1);
      }
      this.$nextTick(() => {
        this.energyConsumptionTemp[index].meterReadNumber = pval
      })
    },
    emitClose () {
      this.$emit('close')
    },

    submit () {
      this.$emit('update:energyConsumption', this.energyConsumptionTemp)
      this.$emit('submit', this.energyConsumptionTemp)  // 暂时未用到
      this.emitClose()
    },
  },
}
</script>

<style>
.dlg-btn-group {
  float: right;
  margin-top: 24px;
  padding: 16px 0;
}
</style>

<style scoped>
.unit {
  font-size: 12px;
  color: #666;
  position: relative;
  left: -1.8em;
  z-index: 10;
}

.el-table .el-input {
  width: 90%;
}

.number-input input[type='number']::-webkit-inner-spin-button,
.number-input input[type='number']::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.tip-title {
  color: #ff4949;
  font-size: 12px;
  line-height: 1;
  padding-top: 3px;
  /* padding-bottom: 2px; */
  /* height: 17px; */
  text-align: left;
  font-weight: 500;
  /* position: absolute; */
  /* top: 100%; */
  /* left: 0; */
}
</style>



// WEBPACK FOOTER //
// src/components/forms/ReletContractForm/EnergyForm.vue